import { c as _c } from "react/compiler-runtime";
import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react';
import { forwardRef } from 'react';
export interface RadioProps extends ChakraRadioGroup.ItemProps {
  rootRef?: React.Ref<HTMLDivElement>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}
export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(props, ref) {
  const $ = _c(16);
  let children;
  let inputProps;
  let rest;
  let rootRef;
  if ($[0] !== props) {
    ({
      children,
      inputProps,
      rootRef,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = inputProps;
    $[3] = rest;
    $[4] = rootRef;
  } else {
    children = $[1];
    inputProps = $[2];
    rest = $[3];
    rootRef = $[4];
  }
  let t0;
  if ($[5] !== inputProps || $[6] !== ref) {
    t0 = <ChakraRadioGroup.ItemHiddenInput ref={ref} {...inputProps} />;
    $[5] = inputProps;
    $[6] = ref;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChakraRadioGroup.ItemIndicator />;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== children) {
    t2 = children && <ChakraRadioGroup.ItemText>{children}</ChakraRadioGroup.ItemText>;
    $[9] = children;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== rest || $[12] !== rootRef || $[13] !== t0 || $[14] !== t2) {
    t3 = <ChakraRadioGroup.Item ref={rootRef} {...rest}>{t0}{t1}{t2}</ChakraRadioGroup.Item>;
    $[11] = rest;
    $[12] = rootRef;
    $[13] = t0;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
});
export const RadioGroup = ChakraRadioGroup.Root;